import { ServerConfig } from "@/config/config";
import { Motd } from "@/models/motd";
import { Axios } from "./auth-service";

const url = `${ServerConfig.host}/admin/motd`;

class MotdServiceClass {
	public async publishToOnlineUsers(message:{[key:string]:string}){
		await Axios.post(`${url}/publish-to-online-users`, message);
	}

	public async getUpcommingMotds():Promise<Motd[]>{
		let response = await Axios.get(`${url}`);
		return response.data.map((d:any)=>new Motd(d));
	}

	public async getItem(id:number):Promise<Motd>{
		let response = await Axios.get(`${url}/${id}`);
		return new Motd(response.data);
	}

	public async createMotd(motd:Motd):Promise<Motd>{
		let response = await Axios.post(`${url}`, motd.getJSON());
		return new Motd(response.data);
	}

	public async updateMotd(motd:Motd):Promise<Motd>{
		let response = await Axios.put(`${url}`, motd.getJSON());
		return new Motd(response.data);
	}

	public async deleteMotd(motd:Motd) {
		await Axios.delete(`${url}/${motd.id}`);
	}
}


export const MotdService = new MotdServiceClass();